<template>
  <DragDialog
    title="转换队列"
    :width="1400"
    :visible.sync="visible"
    :footerBtn="[]"
    :cancel="cancel">
    <div class="operation-btn-box">
      <div class="common-button-box">
        <el-button
          size="small"
          class="normal-btn"
          @click="batchCancelProjConvert">
          批量取消
        </el-button>
      </div>
    </div>
    <div class="common-table-box">
      <el-table
        class="publish-table"
        ref="modelTable"
        :height="500"
        :data="queueList"
        highlight-selection-row
        v-loading="tableLoading"
        :header-row-class-name="customHeader"
        :row-class-name="getRowClassName"
        @select="selectChange"
        @select-all="selectChange">
        <el-table-column
          type="selection"
          :selectable="isRowSelectable"
          width="60" />
        <el-table-column
          label="序号"
          type="index"
          width="55" />
        <el-table-column label="转换节点">
          <template v-slot="{ row }">
            <span>{{ row.zoneId ? row.zoneId : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="队列名称">
          <template v-slot="{ row }">
            <span>{{ row.queueName ? row.queueName : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="用户名称"
          width="110">
          <template v-slot="{ row }">
            <span v-if="$theme.get().value !== 'dark'">{{
              row.phoneNum ? row.phoneNum : '--'
            }}</span>
            <span v-else>{{ row.userName ? row.userName : '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="文件名称"
          width="160">
          <template v-slot="{ row }">
            <span
              class="text-overflow"
              :title="row.dataSetName">
              {{ row.dataSetName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="文件大小"
          width="100">
          <template v-slot="{ row }">
            <span>{{ row.fileSize }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="请求时间"
          width="180">
          <template v-slot="{ row }">
            <span v-if="row.convertStatus === 1">--</span>
            <span v-if="row.convertStatus === 2">{{ row.startTime }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template v-slot="{ row }">
            <div
              v-if="row.owned && row.isAuthorized"
              class="owned-proj-status-box">
              <span
                v-if="row.convertStatus === 1"
                class="transform-waiting">
                排队中
              </span>
              <span
                v-if="row.convertStatus === 2"
                class="transform-run">
                转换中
              </span>
              <span
                v-if="row.convertStatus === 5"
                class="transform-normal">
                停止中
              </span>
            </div>
            <div v-else>
              <span
                v-if="row.convertStatus === 1"
                class="transform-waiting"
                >排队中</span
              >
              <span
                v-if="row.convertStatus === 2"
                class="transform-run"
                >转换中</span
              >
              <span
                v-if="row.convertStatus === 5"
                class="transform-normal"
                >停止中</span
              >
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="转换进度"
          width="260">
          <template v-slot="{ row }">
            <div
              v-if="isProgressVisible(row)"
              class="common-progress-box">
              <el-progress
                class=""
                :show-text="false"
                :percentage="row.ratio" />
              <div class="custom-text">
                <div class="text">{{ `${row.ratio}%` }}</div>
                <div class="progress-name-box">
                  {{ row.ratioMsg ? row.ratioMsg : '' }}
                </div>
              </div>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="200">
          <template v-slot="{ row }">
            <div class="common-button-box operation-cell">
              <el-button
                type="text"
                size="small"
                :disabled="isMoveQueueBtnDisabled(row)"
                @click="topUpDataSet(row)">
                置顶
              </el-button>
              <el-button
                type="text"
                size="small"
                :disabled="isMoveQueueBtnDisabled(row)"
                @click="moveQueue(row, true)">
                上移
              </el-button>
              <el-button
                type="text"
                size="small"
                :disabled="isMoveQueueBtnDisabled(row)"
                @click="moveQueue(row, false)">
                下移
              </el-button>
              <el-button
                type="text"
                size="small"
                :title="getCancelBtnTitle(row)"
                :disabled="isCancelBtnDisabled(row)"
                @click="cancelProjectTransform(row)">
                取消
              </el-button>
            </div>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="common-empty-box">
            <bj-empty
              :image="require('@/assets/img/no-data.png')"
              class="empty-page">
              <template slot="description">
                <div class="empty-text">抱歉，没有找到相关内容</div>
              </template>
            </bj-empty>
          </div>
        </template>
      </el-table>
    </div>
    <div
      v-if="isLegendVisible()"
      class="legend-box">
      <div class="icon-box" />
      <div class="text-box">置灰部分表示正有其他用户在使用转换队列</div>
    </div>
  </DragDialog>
</template>

<script>
import DragDialog from '@/components/CustomDragDialog.vue'

import { formatFileSize } from '@/utils/generalMethods'

import {
  getConvertingQueue,
  topUpQueueService,
  moveConvertQueue,
  getProjectsConvertingProgress,
  stopConvertingProject,
  delQueueProject,
  batchRemoveConvertQueueService
} from '@/service/interface'

export default {
  data() {
    return {
      tableLoading: false,
      queueTimer: null,
      queueList: [],
      customHeader: '',
      selectDatasets: {}
    }
  },
  props: {
    visible: Boolean,
    closeDialog: Function
  },
  components: {
    DragDialog
  },
  watch: {
    visible: function (newVal) {
      if (newVal) {
        this.initQueueList()
      } else {
        this.destroyQueueTimer()

        this.queueList = []
      }
    }
  },
  mounted() {
    setTimeout(() => {
      const currentBody = this.$refs.modelTable?.bodyWrapper
      currentBody &&
        currentBody.addEventListener('scroll', ev => {
          const scrollTop = ev.target.scrollTop
          this.customHeader = scrollTop > 10 ? 'darkHeader' : ''
        })
    }, 1500)
  },
  beforeDestroy() {
    this.destroyQueueTimer()

    this.queueList = []
  },
  methods: {
    batchCancelProjConvert() {
      if (!this.selectDatasets.length) {
        this.$message.warning('请先选择需要取消的转换任务')
        return
      }

      let dataSets = this.selectDatasets.filter(el => el.convertStatus === 1)
      let warningMsg = ''
      if (dataSets.length === this.selectDatasets.length) {
        warningMsg = '确定取消选中的转换任务？'
      } else {
        // prettier-ignore
        warningMsg = "当前仅支持取消排队中的转换任务，其他转换任务将跳过，确定取消排队中的转换任务？";
      }

      this.$confirm(warningMsg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let dataSetIds = dataSets.map(el => el.dataSetId)
          batchRemoveConvertQueueService({ dataSetIds }).then(response => {
            if (response.isSuccess) {
              this.refreshQueueList().then(() => {
                this.$message.success('取消成功')
              })
            }
          })
        })
        .catch(error => {
          console.log('An error occurred:', error)
        })
    },
    initQueueList() {
      this.tableLoading = true
      getConvertingQueue({}).then(response => {
        if (response.isSuccess) {
          let queueList = response.data
          this.queueList = this.formatQueueList(queueList)
          let convertingDataSets = this.queueList.filter(
            el => el.convertStatus === 2 && el.owned
          )
          if (convertingDataSets.length && !this.queueTimer) {
            this.updateConvertProgress(convertingDataSets)
            this.queueTimer = setInterval(
              this.updateConvertProgress,
              10000,
              convertingDataSets
            )
          }

          this.tableLoading = false
        } else {
          this.tableLoading = false
          this.$message.error(response.errMsg)
        }
      })
    },
    updateConvertProgress(convertingDataSets) {
      let dataSetIds = convertingDataSets.map(el => el.dataSetId)
      getProjectsConvertingProgress({ dataSetIds }).then(response => {
        if (response.isSuccess) {
          let dataList = response.data
          for (let i = 0; i < dataList.length; i++) {
            let dataInfo = dataList[i]
            if (dataInfo.ratio === -1) {
              this.refreshQueueList()
              break
            }

            let ratio = Math.round(dataInfo.ratio / 100) / 100
            let find = this.queueList.find(
              el => el.dataSetId === dataInfo.dataSetId
            )

            if (ratio === 100) {
              this.refreshQueueList()
              break
            } else {
              this.$set(find, 'ratio', ratio)
              this.$set(find, 'ratioMsg', dataInfo.message)
            }
          }
        }
      })
    },
    refreshQueueList() {
      return new Promise(resolve => {
        getConvertingQueue({}).then(response => {
          if (response.isSuccess) {
            let queueList = response.data

            queueList.forEach(item => {
              let find = this.queueList.find(
                el => el.dataSetId === item.dataSetId
              )
              if (find && find.ratio) {
                item.ratio = find.ratio
                item.ratioMsg = find.ratioMsg
              }
            })
            this.queueList = this.formatQueueList(queueList)

            let convertingDataSets = this.queueList.filter(
              el => el.convertStatus === 2 || el.convertStatus === 5
            )
            convertingDataSets = convertingDataSets.filter(el => el.owned)
            this.destroyQueueTimer()
            if (convertingDataSets.length && !this.queueTimer) {
              this.updateConvertProgress(convertingDataSets)
              this.queueTimer = setInterval(
                this.updateConvertProgress,
                10000,
                convertingDataSets
              )
            }
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    topUpDataSet(dataSetInfo) {
      let dataSetId = dataSetInfo.dataSetId
      topUpQueueService({ dataSetId }).then(response => {
        if (response.isSuccess) {
          this.refreshQueueList().then(() => {
            this.$message.success('置顶成功')
          })
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    moveQueue(datasetInfo, moveDirection) {
      let params = {
        dataSetId: datasetInfo.dataSetId,
        moveDirection
      }
      moveConvertQueue(params).then(response => {
        if (response.isSuccess) {
          this.refreshQueueList().then(() => {
            this.$message.success('移动成功')
          })
        } else {
          this.$message.error(response.errMsg)
        }
      })
    },
    cancelProjectTransform(datasetInfo) {
      if (datasetInfo.convertStatus === 2) {
        let params = {
          dataSetId: datasetInfo.dataSetId,
          isStart: false
        }
        stopConvertingProject(params).then(response => {
          if (response.isSuccess) {
            this.refreshQueueList().then(() => {
              this.$message.success('取消成功')
            })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      } else {
        let params = {
          dataSetId: datasetInfo.dataSetId,
          isForce: true
        }
        delQueueProject(params).then(response => {
          if (response.isSuccess) {
            this.refreshQueueList().then(() => {
              this.$message.success('删除成功')
            })
          } else {
            this.$message.error(response.errMsg)
          }
        })
      }
    },
    cancel() {
      this.$eventManage.fire('refresh-catalogTree')
      this.$eventManage.fire('refreshTable')
      this.closeDialog()
    },
    formatQueueList(queueList) {
      let waiting = []
      let converting = []
      let isOwnedProjExist = queueList.some(el => el.owned)
      if (!isOwnedProjExist) {
        queueList = queueList.filter(el => el.owned)
      }

      queueList.forEach(item => {
        let size = formatFileSize(item.fileTotalSize).fileSize
        let unit = formatFileSize(item.fileTotalSize).unit
        let fileSize = `${size}${unit}`
        item.fileSize = fileSize

        if (item.convertStatus === 2) {
          converting.push(item)
          if (!item.ratio) {
            item.ratio = 0
            item.ratioMsg = ''
          }
        } else {
          waiting.push(item)
        }
        converting.sort((obj1, obj2) => obj1.queueIndex - obj2.queueIndex)
        waiting.sort((obj1, obj2) => obj1.queueIndex - obj2.queueIndex)
      })
      return [...converting, ...waiting]
    },
    destroyQueueTimer() {
      if (this.queueTimer) {
        clearInterval(this.queueTimer)
        this.queueTimer = null
      }
    },
    selectChange(selection) {
      this.selectDatasets = selection
    },
    getRowClassName(rowObject) {
      let className = ''
      let rowInfo = rowObject.row
      if (!rowInfo.owned || !rowInfo.isAuthorized) {
        className = 'not-owned-row-box'
      }
      return className
    },
    isRowSelectable(dataSetInfo) {
      return dataSetInfo.owned
    },
    isProgressVisible(dataSetInfo) {
      return dataSetInfo.convertStatus === 2 && dataSetInfo.owned
    },
    isMoveQueueBtnDisabled(dataSetInfo) {
      let isDisabled = false
      if (!dataSetInfo.owned) {
        isDisabled = true
        return isDisabled
      }

      let convertStatus = dataSetInfo.convertStatus
      if (convertStatus === 2 || convertStatus === 5) {
        isDisabled = true
        return isDisabled
      }

      return isDisabled
    },
    isCancelBtnDisabled(dataSetInfo) {
      let isDisabled = false
      if (!dataSetInfo.owned) {
        isDisabled = true
        return isDisabled
      }

      if (dataSetInfo.convertStatus === 5) {
        isDisabled = true
        return isDisabled
      }

      return isDisabled
    },
    getCancelBtnTitle(dataSetInfo) {
      let title = ''
      if (!dataSetInfo.owned) {
        return title
      }

      if (dataSetInfo.convertStatus === 1) {
        title = '取消转换'
      }

      if (dataSetInfo.convertStatus === 2) {
        title = '停止转换'
      }

      return title
    },
    isLegendVisible() {
      let isVisible = this.queueList.some(el => !el.owned)
      return isVisible
    },
    formatFileSize
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.operation-btn-box {
  :deep(.not-owned-row-box) {
    opacity: 0.3;
  }
}

.common-table-box {
  margin-top: 10px;
  height: 500px;

  :deep(.not-owned-row-box) {
    opacity: 0.3;
  }

  .owned-proj-status-box {
    .queuing-status {
      color: #3588fa;
    }

    .converting-status {
      color: #73fbfd;
    }

    .stoping-status {
      color: #909399;
    }
  }

  .common-progress-box {
    display: flex;

    .el-progress {
      width: 80%;
    }

    .custom-text {
      width: 60px;
      line-height: 12px;
      font-size: 12px;
      text-align: center;

      .text {
        color: #73fbfd;
      }

      .progress-name-box {
        position: absolute;
        top: 5px;
        left: 0px;
        width: calc(100% - 50px);
        color: #73fbfd;
      }
    }
  }

  .common-button-box {
    display: flex;

    // .el-button {
    //   margin-right: 5px;
    // }
  }

  :deep(.el-table) {
    .el-table-column--selection {
      .el-checkbox__input.is-disabled {
        .el-checkbox__inner {
          background: #6e6e6e;
          border-color: #6e6e6e;
        }
      }
    }

    .el-table__body-wrapper {
      overflow-x: hidden;
    }
  }
}

.legend-box {
  display: flex;
  align-items: center;
  margin-top: 10px;
  opacity: 0.3;

  .icon-box {
    width: 20px;
    height: 14px;
    border-radius: 2px;
    background: var(--table-text-color);
    margin-top: 3px;
  }

  .text-box {
    margin-left: 10px;
    font-size: 12px;
    color: var(--table-text-color);
  }
}
</style>
